<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add Phone Number</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form class="phone-number-form" [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      @if (!isNew) {
        <mat-form-field>
          <mat-label>Phone Number</mat-label>
          <input
            [lcsSingleSelect]="ndtPhoneNumberSelect"
            ndtPhoneNumberSelect
            autocomplete="off"
            type="text"
            formControlName="phoneNumber"
            id="phone-number-select"
            [onlyShowNoAccountPhoneNumbers]="true"
            required
            />
            <ndt-phone-number-select
              #ndtPhoneNumberSelect
              isIncludeEmptyOption="false"
              [phoneNumbersToExclude]="existingPhoneNumbers"
            ></ndt-phone-number-select>
            @if (form.get('phoneNumber')?.hasError('required')) {
              <mat-error> Phone Number is Required. </mat-error>
            }
            @if (form.get('phoneNumber')?.hasError('pattern')) {
              <mat-error>
                Please enter a valid phone number.</mat-error
                >
            }
          </mat-form-field>
        } @else {
          <mat-form-field>
            <mat-label>Number</mat-label>
            <input
              matInput
              autocomplete="off"
              type="text"
              formControlName="phoneNumber"
              required
              id="e7555726-9d4f-4e2a-acd9-d1492699010d"
              #phoneNumber
              />
              @if (!form.controls.phoneNumber.valid) {
                <mat-error matError
                  >Please enter a valid phone number</mat-error
                  >
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>Provider</mat-label>
              <input
                matInput
                autocomplete="off"
                type="text"
                formControlName="providerId"
                id="providerId"
                lcsStaticSelect
                [lcsSingleSelect]="providerSelect"
                [lcsStaticSelectValue]="form.get('providerId')?.value"
                required
                (search)="providerSearch($event)"
                (reset)="providerReset()"
                />
                @if (form.get('providerId')?.hasError('required')) {
                  <mat-error>Provider is Required. </mat-error>
                }
                <lcs-static-select #providerSelect [displayWith]="providerDisplayWith" [autoActiveFirstOption]="false">
                  @for (provider of providers; track provider) {
                    <lcs-option [value]="provider">
                      {{ provider }}
                    </lcs-option>
                  }
                </lcs-static-select>
              </mat-form-field>
              <div class="checkbox-group">
                <mat-checkbox formControlName="isActive" id="account-phone-number-active">Active</mat-checkbox>
                <mat-checkbox formControlName="isPorted" id="6b5b1961-a45f-49b8-9c55-3b8f400b403f">Ported</mat-checkbox>
              </div>
              <br />
              <mat-form-field>
                <mat-label>Date Ported</mat-label>
                <input
                  matInput
                  lcsDatepicker
                  autocomplete="off"
                  formControlName="datePorted"
                  [lcsDatepickerPanel]="datepickerPanel"
                  id="bfb0c3d9-f6a9-4482-b9fa-176259c5c4d2"
                  />
                  @if (form.get('datePorted')?.hasError('required')) {
                    <mat-error>Date Ported is Required. </mat-error>
                  }
                  <lcs-datepicker-toggle matSuffix [for]="datepickerPanel"></lcs-datepicker-toggle>
                  <lcs-datepicker-panel #datepickerPanel></lcs-datepicker-panel>
                </mat-form-field>
              }
              <mat-form-field>
                <mat-label>Display Name</mat-label>
                <input matInput autocomplete="off" type="text" formControlName="displayName" #displayNameInput />
              </mat-form-field>
              @if (!isNew) {
                <mat-checkbox formControlName="isActive" id="existing-account-phone-number-active">Active</mat-checkbox>
                <br />
              }

              @if (filteredExtensions?.length) {
                <mat-form-field>
                  <mat-label>Route To</mat-label>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    formControlName="routeTo"
                    id="route-to"
                    lcsStaticSelect
                    [lcsSingleSelect]="routeToSelect"
                    [displayWith]="extensionDisplayWith"
                    [placeholder]="'Select Extension'"
                    />
                    <lcs-static-select #routeToSelect [displayWith]="extensionDisplayWith">
                      <lcs-option></lcs-option>
                      @for (extension of filteredExtensions; track extension) {
                        <lcs-option [value]="extension">
                          {{ extension.number }} - {{ extension.name }} ({{ extension.type.displayName }})
                        </lcs-option>
                      }
                    </lcs-static-select>
                  </mat-form-field>
                }

                @if (existingPhoneNumbers?.length > 0) {
                  <h4 class="phone-number-list-header"> Added Phone Numbers </h4>
                }
                <ul>
                  @for (phoneNumber of existingPhoneNumbers; track phoneNumber) {
                    <li>
                      <div class="phone-number-list-item-wrapper">
                        <div class="account-phone-number-name">
                          {{ phoneNumber.phoneNumber | formatPhoneNumbers }}
                          @if (!phoneNumber.isActive) {
                            <span class="inactive-label">(Inactive)</span>
                          }
                        </div>
                        <div class="account-phone-number-name">
                          {{ phoneNumber.displayName }}
                        </div>
                      </div>
                    </li>
                  }
                </ul>
              </mat-dialog-content>
              <mat-dialog-actions>
                <button type="button" title="Add and Create Another" mat-stroked-button (click)="onCreate(true)">
                  Add and Create Another
                </button>
                <button type="submit" title="Add" mat-raised-button>Add</button>
              </mat-dialog-actions>
            </form>
          </lcs-loading-overlay>
